import Header from "../../sharedComponents/header/header";
import React from "react";
import { inject, observer } from "mobx-react";
import { PolicyStore } from "../../../stores/policyStore";
import Consent from "./consent/consent";
import Checkbox from "@material-ui/core/Checkbox";
import { ProposalStore } from "../../../stores/proposalStore";
import { AdditionalConsentsId, ConsentsConfiguration, RequiredConsentsId } from "../../../helpers/consents";
import { CalculateStore } from "../../../stores/calculateStore";
import { FormControlLabel } from "@material-ui/core";
import { isClientTuzMember } from "../../../helpers/client";
import { UiFlagsStore } from "../../../stores/uiFlagsStore";

interface ConsentsProps {
  policyStore?: PolicyStore;
  proposalStore?: ProposalStore;
  calculateStore?: CalculateStore;
  uiFlagsStore?: UiFlagsStore;
}

export function Consents(props: ConsentsProps) {
  const consents = ConsentsConfiguration.getRequiredConsents();
  const additionalConsents = ConsentsConfiguration.getAdditionalConsents();

  return (
    <div>
      <div className="section consents">
        <Header type="medium" mainHeader="Oświadczenia do zawarcia umowy" />
        {renderAllRequiredConsentsCheckbox()}
        {props.uiFlagsStore!.isDirect && (
          <Consent consentId={RequiredConsentsId.termsOfService} consent={consents.termsOfService} />
        )}
        <Consent consentId={RequiredConsentsId.owu} consent={consents.owu} />
        <Consent consentId={RequiredConsentsId.productCard} consent={consents.productCard} />
        <Consent consentId={RequiredConsentsId.salary} consent={consents.salary} />
        <Consent consentId={RequiredConsentsId.insured} consent={consents.insured} />
        {props.calculateStore!.additionalInsurances.nnwType.checked && (
          <Consent consentId={RequiredConsentsId.nnw} consent={consents.nnw} />
        )}
        {!isClientTuzMember(props.calculateStore!) && <Consent consentId={RequiredConsentsId.accessionToTuz} consent={consents.accessionToTuz} />}
      </div>
      <div className="section additional-consents">
        <Header type="medium" mainHeader="Pozostałe oświadczenia" />
        <Consent consentId={AdditionalConsentsId.dataProcessingForMarketing}
          consent={additionalConsents.dataProcessingForMarketing} />
        <Consent consentId={AdditionalConsentsId.thirdPartyMarketing}
          consent={additionalConsents.thirdPartyMarketing} />
        <Consent consentId={AdditionalConsentsId.electronicMeansMarketing}
          consent={additionalConsents.electronicMeansMarketing} />
        <Consent consentId={AdditionalConsentsId.phoneCallMarketing}
          consent={additionalConsents.phoneCallMarketing} />
      </div>
    </div>
  );

  function renderAllRequiredConsentsCheckbox() {
    return (
      <div className="check-all">
        <FormControlLabel
          control={
            <Checkbox
              checked={props.proposalStore!.checkIfAllRequiredConsentsChecked(props.calculateStore!, props.uiFlagsStore!.isDirect)}
              onChange={(event) => {
                props.proposalStore!.setRequireConsents(event.target.checked, props.calculateStore!, props.uiFlagsStore!.isDirect);
              }}
              disableRipple
            />
          }
          label={
            <div>Zaznacz wszystkie obowiązkowe</div>
          }
        />
      </div>
    );
  }
}

export default inject("calculateStore", "policyStore", "proposalStore", "uiFlagsStore")(observer(Consents));
